export class PayCalculatorValue {
  cents: number = 0;
  decimal: number = 0;
}
